<template>
  <van-loading v-if="loading" color="#0094ff" />
  <div v-else>
    <div v-if="!showServicePeopel" class="templateSend">
      <div class="navBar">
        <NavBar v-if="sourceIsH5" :narBarTitle="$t('待办详情')" />
        <!-- <p class="title">会议详情</p> -->
      </div>
      <div class="meetingInfo">
        <div class="header">
          <div class="headerTitle">
            <div class="mettingTitle">
              {{ submitterName }}{{ $t(' 提交的 会议申请') }}
            </div>
            <div class="mettingTimeDay">
              {{ $t('创建时间：') }}{{ createdTime }}
            </div>
          </div>
          <img :src="imgUrl" alt="" class="statusImg" />
        </div>
        <div class="mainContent">
          <div class="mettingBoard">
            <div class="mettingDet">
              <!-- <img src="@/assets/images/people.png" alt="" /> -->
              <div class="mettingNameText">{{ $t('会议名称：') }}</div>
              <div class="mettingName">
                {{ title }}
              </div>
            </div>
            <div class="mettingDetTime">
              <!-- <img src="@/assets/images/people.png" alt="" /> -->
              <div class="mettingNameText">{{ $t('会议时间：') }}</div>
              <div class="mettingNameTime">
                {{ timeLine }}
              </div>
            </div>
            <div class="mettingDet">
              <!-- <img class="location" src="@/assets/images/location_icon.png" alt="" /> -->
              <div class="mettingNameText">{{ $t('预选会议室：') }}</div>
              <div class="mettingName">
                {{ areaName }}
              </div>
            </div>
            <!-- <div class="mettingDet">
              <div class="mettingNameText">关联会议：</div>
              <div class="mettingBlue">
                {{ relationMeeting }}
              </div>
            </div> -->
            <div class="mettingDet" style="margin-bottom: 0;">
              <!-- <img class="location" src="@/assets/images/starLevel.png" alt="" /> -->
              <div class="mettingNameText">{{ $t('会议等级：') }}</div>
              <div class="mettingName">
                {{
                  this.meetingLevel == 1
                    ? $t('1星')
                    : this.meetingLevel == 2
                      ? $t('2星')
                      : this.meetingLevel == 3
                        ? $t('3星')
                        : $t('无')
                }}
              </div>
            </div>
            <!-- <div class="mettingDet" style="margin-bottom: 0;">
              <div class="mettingNameText">{{ $t('手机号：') }}</div>
              <div class="mettingName">{{ meetingStaffMobile }}</div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="approveInfo">
        <div class="approveInfoTitle">{{ $t('流程') }}</div>
        <van-steps direction="vertical" :active="toDoActive" active-color="#1890FF"
          v-if="this.allData.type == 'MEETING_SERVICE'">
          <van-step v-for="(step, index) in todoApprovalLogs" :key="index">
            <div class="approveTitle">
              <div class="approveTitleLeftTop">
                <div class="approveTitleName">{{ step.operatorName }}</div>
                <div class="approveTitleLine" v-if="index != 0"></div>
                <div class="approveTitleOk" :style="{ color: step.color }" v-if="index != 0">
                  {{ step.operation }}
                </div>
              </div>
              <div class="approveTitleTitme">{{ step.createdTime }}</div>
            </div>
            <div class="approveDo" v-if="step.info">{{ step.info }}</div>
            <div v-if="step.remarks" class="approveChangeSmall">
              <div class="approveTitleLeft">
                <div class="changeText" :style="{ marginRight: '8px' }">
                  {{ $t('会务服务质量点评') }}
                </div>
                <van-rate v-model="step.remarks" :count="5" color="#FAAD14" readonly />
              </div>
            </div>
          </van-step>
        </van-steps>
        <van-steps direction="vertical" :active="toDoActive" active-color="#1890FF" v-else>
          <van-step v-for="(step, index) in todoApprovalLogs" :key="index">
            <div class="approveTitle">
              <div class="approveTitleLeftTop">
                <div class="approveTitleName">{{ step.operatorName }}</div>
                <div class="approveTitleLine" v-if="index != 0"></div>
                <div class="approveTitleOk" :style="{ color: step.color }" v-if="index != 0">
                  {{ step.operation }}
                </div>
              </div>
              <div class="approveTitleTitme">{{ step.createdTime }}</div>
            </div>
            <div class="approveDo" v-if="step.info">{{ step.info }}</div>
            <div class="approveCancel" v-if="step.remarks">
              {{ step.remarks }}
            </div>
            <div class="approveChange" v-if="step.remarksObj">
              <div class="approveTitleLeft">
                <div class="changeLabel">{{ $t('分配到') }}</div>
                <div class="changeTextLong">
                  {{ step.remarksObj.meetingRoomName }}
                </div>
              </div>
              <div class="approveTitleLeft">
                <div class="changeLabel">{{ $t('会议等级调整为') }}</div>
                <div class="changeText">
                  {{
                    step.remarksObj.meetingLevel == 1
                      ? $t('1星')
                      : step.remarksObj.meetingLevel == 2
                        ? $t('2星')
                        : step.remarksObj.meetingLevel == 3
                          ? $t('3星')
                          : $t('无')
                  }}
                </div>
              </div>
            </div>
          </van-step>
        </van-steps>
      </div>
      <div class="footerStyle" v-if="isMydone">
        <div @click="onRefuse()" :class="isMydone == 1 ? 'refuseButton' : 'refuseButtonSmall'"
          v-if="isMydone == 1 || isMydone == 5">
          {{ $t('拒绝') }}
        </div>
        <div @click="onOk()" :class="isMydone == 1 ? 'okButton' : 'okButtonSmall'"
          v-if="isMydone == 1 || isMydone == 5">
          {{ $t('同意') }}
        </div>
        <div @click="onEdit()" :class="isMydone == 4
          ? 'allocationBotton'
          : isMydone == 6
            ? 'okButton'
            : 'okButtonSmall'
          " v-if="isMydone == 4 || isMydone == 6 || isMydone == 12" :style="{
            'margin-right': isMydone == 6 || isMydone == 12 ? '16px' : '0px',
          }">
          {{ $t('修改') }}
        </div>
        <div @click="onCancel()" :class="isMydone == 3
          ? 'allocationBotton'
          : isMydone == 6
            ? 'okButton'
            : 'okButtonSmall'
          " v-if="isMydone == 3 || isMydone == 6 || isMydone == 12">
          {{ $t('取消') }}
        </div>
        <div @click="onRevoke()" :class="isMydone == 2 ? 'allocationBottonGray' : 'okButtonGraySmall'"
          v-if="isMydone == 2 || isMydone == 5 || isMydone == 12">
          {{ $t('撤销') }}
        </div>
        <div @click="onAllocation()" class="allocationBotton" v-if="isMydone == 7">
          {{ $t('分配人员') }}
        </div>
        <div @click="onAllocation()" :class="isMydone == 10 ? 'allocationBotton' : 'okButton'"
          :style="{ 'margin-right': isMydone == 11 ? '16px' : '0px' }" v-if="isMydone == 10 || isMydone == 11">
          {{ $t('重新分配') }}
        </div>
        <div @click="onDone()" :class="isMydone == 8 ? 'allocationBotton' : 'okButton'"
          v-if="isMydone == 8 || isMydone == 11">
          {{ $t('服务完成') }}
        </div>
        <div @click="onComment()" class="allocationBotton" v-if="isMydone == 9">
          {{ $t('点评') }}
        </div>
      </div>
      <van-popup v-model="showRevoke" position="bottom" safe-area-inset-bottom>
        <div class="popupStyle">
          <div class="popupHeader">
            <div class="popupClose" @click="clickRevoke()">X</div>
            <div class="popupTitle">{{ $t('撤销该流程') }}</div>
          </div>
          <div class="popupText">
            {{ $t('确认撤销此会议室预约审批流程？') }}
          </div>
          <div class="bookBoxRevoke">
            <van-button round block native-type="submit" class="blue-btn" @click="doRevoke()" :disable="isUseRevoke">{{
              $t('撤销')
            }}</van-button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="showCancel" position="bottom" safe-area-inset-bottom>
        <div class="popupStyle">
          <div class="popupHeader">
            <div class="popupClose" @click="clickCancelClose()">X</div>
            <div class="popupTitle">{{ $t('取消该流程') }}</div>
          </div>
          <van-field v-model="reasonMessage" rows="7" autosize type="textarea" :placeholder="$t('请输入取消原因')"
            size="14px" />
          <div class="popupRemark">
            {{ $t('流程已审批结束，取消后同步取消预约的会议及会议室') }}
          </div>
          <div class="bookBoxCancel">
            <van-button round block native-type="submit" :class="reasonMessage ? 'blue-btn' : 'grey-btn'"
              @click="doCancel()" :disable="isUseCancel">{{ $t('取消') }}</van-button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="showOk" position="bottom" safe-area-inset-bottom>
        <div class="popupStyle">
          <div class="popupHeader">
            <div class="popupClose" @click="clickOkClose()">X</div>
            <div class="popupTitle">{{ $t('同意审批') }}</div>
          </div>
          <div class="popupBlock" @click="showArea = true">
            <div class="popupOk">
              <div class="commentStyle">{{ $t('预选会议室：') }}</div>
              <div class="okTextStyle">{{ meetingChoseRoomName }}</div>
            </div>
            <img src="@/assets/images/dropdown.png" alt="" class="dropdownImg" />
          </div>
          <div class="popupOkOther">
            <div class="commentStyle" style="margin-bottom: 10px">
              {{ $t('会议等级：') }}
            </div>
            <van-radio-group v-model="meetingChoseLevel" direction="horizontal">
              <van-radio :name="0">{{ $t('无') }}</van-radio>
              <van-radio :name="1">{{ $t('1星') }}</van-radio>
              <van-radio :name="2">{{ $t('2星') }}</van-radio>
              <van-radio :name="3">{{ $t('3星') }}</van-radio>
            </van-radio-group>
          </div>
          <div class="bookBoxOkOther">
            <van-button round block native-type="submit" :class="meetingChoseRoomName &&
              (meetingChoseLevel == 0 ||
                meetingChoseLevel == 1 ||
                meetingChoseLevel == 2 ||
                meetingChoseLevel == 3)
              ? 'blue-btn'
              : 'grey-btn'
              " @click="doOk()" :disabled="isUseDoOk">{{ $t('完成') }}</van-button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="showEdit" position="bottom" safe-area-inset-bottom>
        <div class="popupStyle">
          <div class="popupHeader">
            <div class="popupClose" @click="clickEditClose()">X</div>
            <div class="popupTitle">{{ $t('编辑审批') }}</div>
          </div>
          <div class="popupBlock" @click="showArea = true">
            <div class="popupOk">
              <div class="commentStyle">{{ $t('预选会议室：') }}</div>
              <div class="okTextStyle">{{ meetingChoseRoomName }}</div>
            </div>
            <img src="@/assets/images/dropdown.png" alt="" class="dropdownImg" />
          </div>
          <div class="popupOkOther">
            <div class="commentStyle" style="margin-bottom: 10px">
              {{ $t('会议等级：') }}
            </div>
            <van-radio-group v-model="meetingChoseLevel" direction="horizontal">
              <van-radio :name="0">{{ $t('无') }}</van-radio>
              <van-radio :name="1">{{ $t('1星') }}</van-radio>
              <van-radio :name="2">{{ $t('2星') }}</van-radio>
              <van-radio :name="3">{{ $t('3星') }}</van-radio>
            </van-radio-group>
          </div>
          <div class="bookBoxOkOther">
            <van-button round block native-type="submit" :class="meetingChoseRoomName &&
              (meetingChoseLevel == 0 ||
                meetingChoseLevel == 1 ||
                meetingChoseLevel == 2 ||
                meetingChoseLevel == 3)
              ? 'blue-btn'
              : 'grey-btn'
              " @click="doEdit()" :disabled="isUseEdit">{{ $t('完成') }}</van-button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="showRefuse" position="bottom" safe-area-inset-bottom>
        <div class="popupStyle">
          <div class="popupHeader">
            <div class="popupClose" @click="clickRefuseClose()">X</div>
            <div class="popupTitle">{{ $t('拒绝审批') }}</div>
          </div>
          <van-field v-model="refuseMessage" rows="7" autosize type="textarea" :placeholder="$t('请输入拒绝原因')"
            size="14px" />
          <div class="bookBox">
            <van-button round block native-type="submit" class="danger-btn" @click="doRefuse()"
              :disabled="isUseRefuse">{{
                $t('拒绝') }}</van-button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="showArea" position="bottom" safe-area-inset-bottom>
        <div>
          <div class="timeListTitle">{{ $t('选择会议室') }}</div>
          <van-checkbox-group v-model="areaResult" class="timeList" max="1">
            <div style="position: absolute; top: 0; height: 318px">
              <van-checkbox :name="index" class="timeListCard" icon-size="21px" v-for="(item, index) in areaList"
                :key="index">
                <div class="timeListRange">{{ item.name }}</div>
              </van-checkbox>
            </div>
          </van-checkbox-group>
        </div>
        <div class="bookBox">
          <van-button round block type="info" native-type="submit" class="blue-btn" @click="toMeetingInform">{{ $t('确定')
          }}</van-button>
        </div>
      </van-popup>
      <van-popup v-model="showAllocation" position="bottom" safe-area-inset-bottom>
        <div class="popupStyle">
          <div class="popupHeader">
            <div class="popupClose" @click="clickAllocationClose()">X</div>
            <div class="popupTitle">{{ $t('分配会务服务人') }}</div>
          </div>
          <div>
            <div class="popupBlock" @click="cilkcshowServicePeopel()">
              <div class="popupOk">
                <div class="commentStyle">{{ $t('服务人：') }}</div>
                <div :class="servicePeopelName ? 'okTextStyle' : 'okTextGreyStyle'">
                  {{ servicePeopelName ? servicePeopelName : $t('请选择') }}
                </div>
              </div>
              <img src="@/assets/images/dropdown.png" alt="" class="dropdownImg" />
            </div>
          </div>
          <div class="bookBoxAllocation">
            <van-button round block native-type="submit" :class="servicePeopelName ? 'blue-btn' : 'grey-btn'"
              @click="doAllocation()" :disabled="isUseAllocation">{{ $t('分配') }}</van-button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="showDone" position="bottom" safe-area-inset-bottom>
        <div class="popupStyle">
          <div class="popupHeader">
            <div class="popupClose" @click="clickDoneClose()">X</div>
            <div class="popupTitle">{{ $t('会务服务') }}</div>
          </div>
          <div class="popupText">{{ $t('会务服务工作是否完成？') }}</div>
          <div class="bookBoxRevoke">
            <van-button round block native-type="submit" class="blue-btn" @click="doDone()" :disable="isUseDone">{{
              $t('完成') }}</van-button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="showComment" position="bottom" safe-area-inset-bottom>
        <div class="popupStyle">
          <div class="popupHeader">
            <div class="popupClose" @click="clickCommentClose()">X</div>
            <div class="popupTitle">{{ $t('会务点评') }}</div>
          </div>
          <div class="popupComment">
            <div class="commentStyle">{{ $t('会务点评：') }}</div>
            <van-rate v-model="commentValue" :count="5" color="#FAAD14" />
          </div>
          <div class="bookBox">
            <van-button round block native-type="submit" :class="commentValue >= 1 ? 'blue-btn' : 'grey-btn'"
              @click="doComment()" :disabled="isUseComment">{{ $t('完成') }}</van-button>
          </div>
        </div>
      </van-popup>
      <van-dialog v-model="showToast" show-cancel-button confirmButtonColor="#009BFF" cancelButtonColor="#009BFF"
        @confirm="IsDoOk()" class="outsiderStyle" :cancelButtonText="$t('取消')" :confirmButtonText="$t('确认')">
        <template #title>
          <div class="outsider-title">
            {{ '该会议室没有会务服务，是否要更换' }}
          </div>
        </template>
      </van-dialog>
      <van-dialog v-model="showEditToast" show-cancel-button confirmButtonColor="#009BFF" cancelButtonColor="#009BFF"
        @confirm="IsDoEdit()" class="outsiderStyle" :cancelButtonText="$t('取消')" :confirmButtonText="$t('确认')">
        <template #title>
          <div class="outsider-title">
            {{ '该会议室没有会务服务，是否要更换' }}
          </div>
        </template>
      </van-dialog>
    </div>
    <Address :userList="userList" v-if="showServicePeopel" @back="toInform" @confirm="confirmSearch"
      :selectedList="[]" />
  </div>
</template>
<script>
import dayjs from 'dayjs'
import Vue from 'vue'
import NavBar from '@/components/navBar'
import {
  getMeetingRoomByArea,
  processingData,
  cancelProcess,
  editorById,
  revokeProcess,
  getProcessById,
  assignPersonnel,
  serviceComplete,
  submitterGrade,
  getUserList,
  getMeetingRoomById,
} from '@/services/api'
import {
  Icon,
  Button,
  Toast,
  Dialog,
  Popup,
  ImagePreview,
  Field,
  Uploader,
  Collapse,
  CollapseItem,
  Loading,
  Step,
  Steps,
  Rate,
} from 'vant'
import VideoPlayer from 'vue-video-player'
import Address from '../representative/address.vue'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(ImagePreview)
Vue.use(VideoPlayer)
Vue.use(Icon)
Vue.use(Button)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Field)
Vue.use(Popup)
Vue.use(Uploader)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Loading)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Rate)

export default {
  name: 'TemplateSend',
  components: {
    NavBar,
    Address,
  },
  data() {
    return {
      id: '',
      allData: '',
      loading: false,
      user: {},
      submitterName: '',
      areaName: '',
      createdTime: '',
      title: '',
      timeLine: '',
      meetingStaffMobile: '',
      meetingLevel: '',
      sourceIsH5: true,
      relationMeeting: '',
      relationMeetingId: 0,
      meetingList: [],
      appointmentId: '',
      companyCode: '',
      agree: true,
      showRevoke: false,
      isUseRevoke: false,
      showCancel: false,
      isUseCancel: false,
      reasonMessage: '',
      refuseMessage: '',
      meetingInfo: {},
      showRefuse: false,
      isUseRefuse: false,
      showOk: false,
      isUseDoOk: false,
      showArea: false,
      showEdit: false,
      isUseEdit: false,
      areaList: [],
      areaid: '',
      meetingChoseRoomName: '',
      areaResult: [],
      meetingChoseLevel: 0,
      isMydone: '',
      showServicePeopel: false,
      showAllocation: false,
      isUseAllocation: false,
      showComment: false,
      isUseComment: false,
      showDone: false,
      isUseDone: false,
      servicePeopelName: '',
      servicePeopelId: '',
      servicePersonnerlDpt: '',
      commentValue: 0,
      userList: [],
      imgUrl: '',
      showToast: false,
      showEditToast: false,
      todoApprovalLogs: [],
      toDoActive: 0,
      locale: localStorage.getItem('locale') || navigator.language || 'zh-CN',
    }
  },
  methods: {
    async getUsers(companyId) {
      try {
        const res = await getUserList({ companyId })
        let arr = [...res]
        this.userList = arr
      } catch (error) {
        console.log(error)
      }
    },
    getWeekName(week) {
      switch (week) {
        case '1':
          return this.$t('周一')
          break
        case '2':
          return this.$t('周二')
          break
        case '3':
          return this.$t('周三')
          break
        case '4':
          return this.$t('周四')
          break
        case '5':
          return this.$t('周五')
          break
        case '6':
          return this.$t('周六')
          break
        case '7':
          return this.$t('周日')
          break
      }
    },
    async getInfo(appointmentId) {
      getProcessById({ id: appointmentId }).then((res) => {
        if (!res) return
        this.id = res.id
        this.allData = res
        this.getAllTodoApprovalLogs(res)
        let time = ''
        if (
          res.meetingType &&
          res.meetingType == 'WEEKLY' &&
          res.type != 'MEETING_SERVICE'
        ) {
          let day1 = dayjs(res.meetingStartTime.split(' ')[0]).format(
            'YYYY.MM.DD'
          )
          let day2 = dayjs(res.weeklyEndTime).format('YYYY.MM.DD')
          let start = res.meetingStartTime.split(' ')[1]
          let end = res.meetingEndTime.split(' ')[1]
          let startTime = start?.split(':')[0] + ':' + start?.split(':')[1]
          let endTime = end?.split(':')[0] + ':' + end?.split(':')[1]
          let timeLine = day1 + '-' + day2 + ' ' + startTime + '-' + endTime
          let repeatDayOfWeek = res.repeatDayOfWeekString?.split(',') || []
          let timeWeek = ''
          repeatDayOfWeek?.map((v, index) => {
            timeWeek =
              timeWeek +
              this.getWeekName(v) +
              (index != repeatDayOfWeek.length - 1 ? '/' : '')
          })
          time = timeLine + this.$t('（每') + timeWeek + '）'
        } else {
          let day = dayjs(res.meetingStartTime.split(' ')[0]).format(
            'YYYY.MM.DD'
          )
          let start = res.meetingStartTime.split(' ')[1]
          let end = res.meetingEndTime.split(' ')[1]
          let startTime = start?.split(':')[0] + ':' + start?.split(':')[1]
          let endTime = end?.split(':')[0] + ':' + end?.split(':')[1]
          time = day + ' ' + startTime + '-' + endTime
        }
        this.timeLine = time
        let createdDay = dayjs(res.createdTime.split(' ')[0]).format(
          'YYYY.MM.DD'
        )
        let createdStart = res.meetingStartTime.split(' ')[1]
        let createdStartTime =
          createdStart?.split(':')[0] + ':' + createdStart?.split(':')[1]
        this.createdTime = createdDay + ' ' + createdStartTime
        this.submitterName = res.submitterName
        this.title = res.title
        this.meetingLevel = res?.meetingAppointmentRecord?.meetingLevel
        this.relationMeeting =
          res?.meetingAppointmentRecord?.relationAppointmentTopic
        this.meetingStaffMobile =
          res?.meetingAppointmentRecord?.meetingStaffMobile
        this.areaName = res?.meetingAppointmentRecord?.meetingRoomDto?.name
        let allApproverIds = res?.approverIds?.split(',')
        allApproverIds = allApproverIds?.map((str) => parseInt(str))
        if (res.type == 'MEETING_SERVICE') {
          if (res.state == 'PENDING') {
            this.isMydone = this.user.id == res.meetingManger ? 7 : ''
            this.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/toAllocated.png') : require('@/assets/images/toAllocatedE.png')
          } else if (res.state == 'ASSIGN') {
            this.isMydone =
              this.user.id == res.servicePersonnerl &&
                this.user.id == res.meetingManger
                ? 11
                : this.user.id == res.servicePersonnerl
                  ? 8
                  : this.user.id == res.meetingManger
                    ? 10
                    : ''
            this.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/waitServer.png') : require('@/assets/images/waitServerE.png')
          } else if (res.state == 'GRADE') {
            this.isMydone = this.user.id == res.submitter ? 9 : ''
            this.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/Review.png') : require('@/assets/images/ReviewE.png')
          } else if (res.state == 'COMPLETED') {
            this.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/CompletedGreen.png') : require('@/assets/images/CompletedGreenE.png')
          } else if (res.state == 'CANCELLED') {
            this.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/Canceled.png') : require('@/assets/images/CanceledE.png')
          }
        } else {
          if (res.state == 'PENDING') {
            if (
              this.user.id == res.submitter &&
              allApproverIds?.includes(this.user.id) &&
              res?.todoApprovalLogs?.some(
                (user) =>
                  user.operator == this.user.id && user.operation !== 'APPLYING'
              )
            ) {
              this.isMydone = 12
            } else if (
              this.user.id == res.submitter &&
              allApproverIds?.includes(this.user.id) &&
              res.todoApprovalLogs?.some(
                (user) =>
                  user.operator == this.user.id && user.operation == 'APPLYING'
              )
            ) {
              this.isMydone = 5
            } else if (
              this.user.id !== res.submitter &&
              allApproverIds?.includes(this.user.id) &&
              res.todoApprovalLogs?.some(
                (user) => user.operator == this.user.id
              )
            ) {
              this.isMydone = 6
            } else if (
              this.user.id !== res.submitter &&
              allApproverIds?.includes(this.user.id) &&
              !res.todoApprovalLogs?.some(
                (user) => user.operator == this.user.id
              )
            ) {
              this.isMydone = 1
            } else if (
              this.user.id == res.submitter &&
              !allApproverIds?.includes(this.user.id)
            ) {
              this.isMydone = 2
            } else {
              this.isMydone = ''
            }
            this.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/Approval.png') : require('@/assets/images/ApprovalE.png')
          } else if (res.state == 'COMPLETED') {
            if (res.meetingType && res.meetingType == 'WEEKLY') {
              let actualTime = ''
              let startDay = dayjs(res.meetingStartTime.split(' ')[0]).format(
                'YYYY-MM-DD'
              )
              let startTime = res.meetingStartTime.split(' ')[1]
              let dayNumber =
                dayjs(startDay).day() == 0 ? 7 : dayjs(startDay).day()
              let repeatDayOfWeek = res.repeatDayOfWeekString?.split(',') || []
              repeatDayOfWeek = repeatDayOfWeek.map((item) => parseInt(item))
              repeatDayOfWeek.sort((a, b) => a - b)
              if (repeatDayOfWeek.includes(dayNumber)) {
                actualTime = res.meetingStartTime
              } else {
                let firstGreater = repeatDayOfWeek.find(
                  (num) => num > dayNumber
                )
                if (firstGreater) {
                  let newDay = dayjs(res.meetingStartTime.split(' ')[0])
                    .add(firstGreater - dayNumber, 'day')
                    .format('YYYY-MM-DD')
                  actualTime = newDay + ' ' + startTime
                } else {
                  let newDay = dayjs(res.meetingStartTime.split(' ')[0])
                    .add(7 - dayNumber + repeatDayOfWeek[0], 'day')
                    .format('YYYY-MM-DD')
                  actualTime = newDay + ' ' + startTime
                }
              }
              this.isMydone =
                allApproverIds.includes(this.user.id) &&
                  dayjs().isBefore(dayjs(actualTime))
                  ? 6
                  : ''
            } else {
              this.isMydone =
                allApproverIds.includes(this.user.id) &&
                  dayjs().isBefore(dayjs(res.meetingStartTime))
                  ? 6
                  : ''
            }
            this.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/CompletedGreen.png') : require('@/assets/images/CompletedGreenE.png')
          } else if (res.state == 'CANCELLED') {
            this.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/Canceled.png') : require('@/assets/images/CanceledE.png')
          } else if (res.state == 'REVOKE') {
            this.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/Revoked.png') : require('@/assets/images/RevokedE.png')
          } else if (res.state == 'EXPIRED') {
            this.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/Expired.png') : equire('@/assets/images/ExpiredE.png')
          } else if (res.state == 'REJECTED') {
            this.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/Refused.png') : require('@/assets/images/RefusedE.png')
          }
        }
      })
    },
    async getAllTodoApprovalLogs(data) {
      let list = []
      if (data.type == 'MEETING_SERVICE') {
        let alltodoApprovalLogs = data.todoApprovalLogs.filter((v) => v.operation != 'SUBMITTER_EDITOR')
        alltodoApprovalLogs.map((item, index) => {
          let time1 = item.createdTime.split(' ')
          let day1 = dayjs(time1[0]).format('MM.DD')
          let start1 = time1[1].split(':')
          let startTime = day1 + ' ' + start1[0] + ':' + start1[1]
          let info = item.operation == 'APPLYING' || item.operation == 'GRADE' ? '' : item.operation == 'ASSIGN' ? this.$t('会务管理人') : item.operation == 'COMPLETED' ? this.$t('会务服务人') : ''
          let operation =
            item.operation == 'ASSIGN'
              ? this.$t('已分配')
              : item.operation == 'COMPLETED'
                ? this.$t('已服务')
                : item.operation == 'GRADE'
                  ? this.$t('已点评')
                  : item.operation == 'CANCELLED'
                    ? this.$t('已取消')
                    : item.operation == 'REASSIGNMENT'
                      ? this.$t('重新分配')
                      : ''
          if (index == 0) {
            list.push({
              operatorName: item.operatorName,
              createdTime: startTime,
              info: this.$t('发起申请'),
            })
          } else {
            list.push({
              operatorName: item.operatorName,
              createdTime: startTime,
              operation: operation,
              color: item.operation == 'CANCELLED' ? '#1E2329' : '#0ECB81',
              info: info,
              remarks: parseInt(item.remarks),
            })
          }
        })
        if (data.state == 'PENDING') {
          // let meetingManger = this.userList
          //   ? this.userList.filter((v) => v.id == data?.meetingManger)
          //   : []
          let meetingMangerName = data?.meetingMangerName
          // meetingManger && meetingManger.length ? meetingManger[0].name : ''
          list.push({
            operatorName: meetingMangerName,
            createdTime: dayjs().format('MM.DD HH:mm'),
            operation: this.$t('待分配'),
            color: '#0ECB81',
            info: this.$t('会务管理人'),
          })
        } else if (data.state == 'ASSIGN') {
          // let servicePersonnerl = this.userList
          //   ? this.userList.filter(
          //     (v) => v.id == this.allData?.servicePersonnerl
          //   )
          //   : []
          let servicePersonnerlName = data?.servicePersonnerlName
          // servicePersonnerl && servicePersonnerl.length
          //   ? servicePersonnerl[0].name
          //   : ''
          list.push({
            operatorName: servicePersonnerlName,
            createdTime: dayjs().format('MM.DD HH:mm'),
            operation: this.$t('待服务'),
            color: '#1E2329',
            info: this.$t('会务服务人'),
          })
          this.toDoActive = list.length - 1
        } else if (data.state == 'GRADE') {
          list.push({
            operatorName: this.allData.submitterName,
            createdTime: dayjs().format('MM.DD HH:mm'),
            operation: this.$t('待点评'),
            color: '#1E2329',
          })
          this.toDoActive = list.length - 1
        }
        this.toDoActive = list.length - 1
        this.todoApprovalLogs = list
      } else {
        let newList = []
        let allApproverIds = data?.approverIds?.split(',')
        allApproverIds = allApproverIds?.map((str) => parseInt(str))
        let info =
          (data.approverDeptManager
            ? this.$t('部门主管审批')
            : data.approverSomeStaff
              ? this.$t('指定员工审批')
              : '') +
          '（' +
          (data.approvalMethod == 'OR_SIGN'
            ? this.$t('或签')
            : this.$t('会签')) +
          '）'
        data.todoApprovalLogs.map((item, index) => {
          let time2 = item.createdTime.split(' ')
          let day2 = dayjs(time2[0]).format('MM.DD')
          let start2 = time2[1].split(':')
          let startTime = day2 + ' ' + start2[0] + ':' + start2[1]
          let operation =
            item.operation == 'APPROVED'
              ? this.$t('已同意')
              : item.operation == 'EDITOR'
                ? this.$t('已修改')
                : item.operation == 'REJECTED'
                  ? this.$t('已拒绝')
                  : item.operation == 'CANCELLED'
                    ? this.$t('已取消')
                    : item.operation == 'REVOKE'
                      ? this.$t('已撤销')
                      : ''
          let remarks = ''
          let remarksObj = ''
          if (item.operation == 'APPROVED' || item.operation == 'EDITOR') {
            remarksObj = item.remarks ? JSON.parse(item.remarks) : ''
          } else {
            remarks = item.remarks
          }
          if (index == 0) {
            newList.push({
              operatorName: item.operatorName,
              createdTime: startTime,
              info: this.$t('发起申请'),
            })
          } else {
            newList.push({
              operatorName: item.operatorName,
              createdTime: startTime,
              operation: operation,
              color:
                item.operation == 'EDITOR' ||
                  item.operation == 'CANCELLED' ||
                  item.operation == 'REVOKE'
                  ? '#1E2329'
                  : item.operation == 'REJECTED'
                    ? '#FF4D4F'
                    : '#0ECB81',
              info: info,
              remarks: remarks ? remarks : undefined,
              remarksObj: remarksObj ? remarksObj : undefined,
            })
          }
        })
        if (data.state == 'PENDING') {
          let leaveId = allApproverIds.filter(
            (leave) =>
              !data.todoApprovalLogs.some(
                (filterObj) =>
                  filterObj.operator == leave &&
                  filterObj.operation != 'APPLYING'
              )
          )
          const resultArray = Object.entries(data.approverNames).map(([id, name]) => ({
            id: Number(id),  // 如果希望id保持数字类型，使用Number()转换
            name: name
          }));
          let allApproverPeople = resultArray.filter((obj) =>
            leaveId.includes(obj.id)
          )
          if (allApproverPeople && allApproverPeople.length) {
            let name = ''
            allApproverPeople.map((v, index) => {
              name =
                name +
                v.name +
                (index == allApproverPeople.length - 1 ? '' : '、')
            })
            newList.push({
              operatorName: name,
              createdTime: dayjs().format('MM.DD HH:mm'),
              operation: this.$t('审批中'),
              color: '#1E2329',
              info: info,
            })
          }
        }
        if (data.state == 'COMPLETED' && data.approvalMethod == 'OR_SIGN') {
          let doPeople = data.todoApprovalLogs.filter(
            (item) => item.operation == 'APPROVED'
          )
          let peopleId =
            doPeople && doPeople.length ? doPeople[0].operator : null
          if (peopleId) {
            let leaveId = allApproverIds.filter((leave) => leave != peopleId)
            const resultArray = Object.entries(data.approverNames).map(([id, name]) => ({
              id: Number(id),  // 如果希望id保持数字类型，使用Number()转换
              name: name
            }));
            let allApproverPeople = resultArray.filter((obj) =>
              leaveId.includes(obj.id)
            )
            allApproverPeople.map((v, index) => {
              newList.push({
                operatorName: v.name,
                createdTime: dayjs().format('MM.DD HH:mm'),
                operation: this.$t('自动同意'),
                color: '#0ECB81',
                info: info,
              })
            })
          }
        }
        if (data.state == 'REJECTED' && data.approvalMethod == 'OR_SIGN') {
          let doPeople = data.todoApprovalLogs.filter(
            (item) => item.operation == 'REJECTED'
          )
          let peopleId =
            doPeople && doPeople.length ? doPeople[0].operator : null
          if (peopleId) {
            let leaveId = allApproverIds.filter((leave) => leave != peopleId)
            const resultArray = Object.entries(data.approverNames).map(([id, name]) => ({
              id: Number(id),  // 如果希望id保持数字类型，使用Number()转换
              name: name
            }));
            let allApproverPeople = resultArray.filter((obj) =>
              leaveId.includes(obj.id)
            )
            allApproverPeople.map((v, index) => {
              newList.push({
                operatorName: v.name,
                createdTime: dayjs().format('MM.DD HH:mm'),
                operation: this.$t('自动拒绝'),
                color: '#0ECB81',
                info: info,
              })
            })
          }
        }
        this.todoApprovalLogs = newList
        this.toDoActive = newList.length - 1
      }
    },
    async getAreaId(developerId) {
      try {
        const res = await getMeetingRoomByArea({
          developerId,
        })
        let tmpArr = [...res]
        tmpArr.forEach((item, idx) => {
          if (item.state === 'nouse') {
            // tmpArr.splice(idx, 1)
          }
        })
        tmpArr.forEach((item) => {
          if (item.state != 'nouse') {
            this.areaList.push({ name: item.name, id: item.id })
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    onRevoke() {
      this.showRevoke = true
    },
    onCancel() {
      this.showCancel = true
      this.reasonMessage = ''
    },
    onRefuse() {
      this.showRefuse = true
      this.refuseMessage = ''
    },
    onOk() {
      this.showOk = true
      this.meetingChoseRoomName = this.areaName
      this.areaid = this.allData.meetingRoomId
      let index = this.areaList.findIndex((item) => {
        return item.id === this.allData.meetingRoomId
      })
      this.meetingChoseLevel =
        this.allData.meetingAppointmentRecord.meetingLevel
      this.areaResult = [index]
    },
    async onEdit() {
      this.showEdit = true
      this.meetingChoseRoomName = this.areaName
      this.areaid = this.allData.meetingRoomId
      let index = this.areaList.findIndex((item) => {
        return item.id === this.allData.meetingRoomId
      })
      this.meetingChoseLevel =
        this.allData.meetingAppointmentRecord.meetingLevel
      this.areaResult = [index]
    },
    async doRevoke() {
      try {
        this.isUseRevoke = true
        await revokeProcess({
          approverId: this.user.id,
          companyId: parseInt(this.user.companyId),
          id: this.id,
        })
        Toast(this.$t('已撤回'))
        this.showRevoke = false
        this.isUseRevoke = false
        this.$router.push('representative')
      } catch (error) {
        Toast.fail(error.response.data)
      } finally {
        this.showRevoke = false
        this.isUseRevoke = false
      }
    },
    async doCancel() {
      if (!this.reasonMessage || this.reasonMessage == ' ') {
        Toast.fail(this.$t('取消原因不能为空'))
        return
      }
      try {
        this.isUseCancel = true
        await cancelProcess({
          approverId: this.user.id,
          companyId: parseInt(this.user.companyId),
          id: this.id,
          remark: this.reasonMessage,
        })
        Toast(this.$t('已取消'))
        this.showCancel = false
        this.isUseCancel = false
        this.$router.push('representative')
      } catch (error) {
        Toast.fail(error.response.data)
      } finally {
        this.showCancel = false
        this.isUseCancel = false
      }
    },
    toMeetingInform() {
      if (this.areaResult.length == 0) {
        Toast.fail(this.$t('会议室不能为空'))
        return
      }
      let index = this.areaResult[0]
      this.meetingChoseRoomName = this.areaList[index].name
      this.areaid = this.areaList[index].id
      this.showArea = false
    },
    async IsDoOk(flag, id) {
      this.showToast = false
      this.isUseDoOk = true
      let remark = {}
      if (
        this.meetingChoseLevel !=
        this.allData.meetingAppointmentRecord.meetingLevel ||
        this.areaid != this.allData.meetingRoomId
      ) {
        remark = {
          meetingRoomName: this.meetingChoseRoomName,
          meetingLevel: this.meetingChoseLevel,
        }
      }
      try {
        await processingData({
          approverId: this.user.id,
          companyId: parseInt(this.user.companyId),
          id: this.id,
          meetingLevel: this.meetingChoseLevel,
          meetingRoomId: this.areaid,
          state: 'APPROVED',
          remark:
            JSON.stringify(remark) === '{}'
              ? undefined
              : JSON.stringify(remark),
          openMeetingService:
            this.areaid != this.allData.meetingRoomId
              ? flag
                ? flag
                : false
              : undefined,
          meetingManger: id ? id : undefined,
        })
        this.showOk = false
        this.isUseDoOk = false
        this.$router.push('representative')
        Toast(this.$t('已同意'))
      } catch (error) {
        Toast.fail(error.response.data)
      } finally {
        this.showOk = false
        this.isUseDoOk = false
      }
    },
    async doOk() {
      if (
        this.areaid != this.allData.meetingRoomId &&
        this.allData.meetingAppointmentRecord.openMeetingService
      ) {
        getMeetingRoomById(this.areaid).then((res) => {
          if (res.openMeetingService && res.meetingManger) {
            this.IsDoOk(res.openMeetingService, res.meetingManger)
          } else {
            this.showToast = true
          }
        })
      } else {
        this.IsDoOk()
      }
    },
    async IsDoEdit(flag, id) {
      this.showEditToast = false
      let remark = {}
      if (
        this.meetingChoseLevel !=
        this.allData.meetingAppointmentRecord.meetingLevel ||
        this.areaid != this.allData.meetingRoomId
      ) {
        remark = {
          meetingRoomName: this.meetingChoseRoomName,
          meetingLevel: this.meetingChoseLevel,
        }
      }
      try {
        this.isUseEdit = true
        await editorById({
          approverId: this.user.id,
          companyId: parseInt(this.user.companyId),
          id: this.id,
          meetingLevel: this.meetingChoseLevel,
          meetingRoomId: this.areaid,
          remark:
            JSON.stringify(remark) === '{}'
              ? undefined
              : JSON.stringify(remark),
          openMeetingService:
            this.areaid != this.allData.meetingRoomId
              ? flag
                ? flag
                : false
              : undefined,
          meetingManger: id ? id : undefined,
        })
        this.showEdit = false
        this.isUseEdit = false
        this.$router.push('representative')
        Toast(this.$t('已修改'))
      } catch (error) {
        Toast.fail(error.response.data)
      } finally {
        this.showEdit = false
        this.isUseEdit = false
      }
    },
    async doEdit() {
      if (
        this.areaid != this.allData.meetingRoomId &&
        this.allData.meetingAppointmentRecord.openMeetingService
      ) {
        getMeetingRoomById(this.areaid).then((res) => {
          if (res.openMeetingService && res.meetingManger) {
            this.IsDoEdit(res.openMeetingService, res.meetingManger)
          } else {
            this.showEditToast = true
          }
        })
      } else {
        this.IsDoEdit()
      }
    },
    async doRefuse() {
      try {
        this.isUseRefuse = true
        await processingData({
          approverId: this.user.id,
          companyId: parseInt(this.user.companyId),
          id: this.id,
          remark: this.refuseMessage,
          state: 'REJECTED',
        })
        Toast(this.$t('已拒绝'))
        this.showRefuse = false
        this.isUseRefuse = false
        this.$router.push('representative')
      } catch (error) {
        Toast.fail(error.response.data)
      } finally {
        this.showRefuse = false
        this.isUseRefuse = false
      }
    },
    clickRevoke() {
      this.showRevoke = false
    },
    clickCancelClose() {
      this.choseData = {}
      this.showCancel = false
    },
    clickOkClose() {
      this.choseData = {}
      this.showOk = false
    },
    clickEditClose() {
      this.choseData = {}
      this.showEdit = false
    },
    clickRefuseClose() {
      this.choseData = {}
      this.showRefuse = false
    },
    onAllocation() {
      let servicePersonnerl = this.userList
        ? this.userList.filter((v) => v.id == this.allData?.servicePersonnerl)
        : []
      this.servicePersonnerl =
        servicePersonnerl && servicePersonnerl.length
          ? servicePersonnerl[0].name
          : ''
      this.showAllocation = true
      this.servicePeopelName = this.servicePersonnerl
        ? this.servicePersonnerl
        : ''
      this.servicePeopelId = this.allData?.servicePeopelId
        ? this.allData?.servicePeopelId
        : ''
      this.servicePersonnerlDpt = this.allData?.servicePersonnerlDpt
        ? this.allData?.servicePersonnerlDpt
        : ''
    },
    onDone() {
      this.showDone = true
    },
    onComment() {
      this.showComment = true
      this.commentValue = 0
    },
    clickAllocationClose() {
      this.showAllocation = false
    },
    clickDoneClose() {
      this.showDone = false
    },
    clickCommentClose() {
      this.showComment = false
    },
    cilkcshowServicePeopel() {
      this.showAllocation = false
      this.showServicePeopel = true
    },
    async doAllocation() {
      if (this.servicePeopelId) {
        try {
          this.isUseAllocation = true
          await assignPersonnel({
            staffId: this.user.id,
            servicePersonnerl: this.servicePeopelId,
            servicePersonnerlDpt: this.servicePersonnerlDpt,
            todoId: this.id,
          })
          this.showAllocation = false
          this.isUseAllocation = false
          Toast(this.$t('已完成分配'))
          this.$router.push('representative')
        } catch (error) {
          Toast.fail(error.response.data)
        } finally {
          this.showAllocation = false
          this.isUseAllocation = false
        }
      } else {
        return
      }
    },
    async doDone() {
      try {
        this.isUseDone = true
        await serviceComplete({
          staffId: this.user.id,
          todoId: this.id,
        })
        this.showDone = false
        this.isUseDone = false
        Toast(this.$t('已完成'))
        this.$router.push('representative')
      } catch (error) {
        Toast.fail(error.response.data)
      } finally {
        this.showDone = false
        this.isUseDone = false
      }
    },
    async doComment() {
      if (this.commentValue < 1) {
        return
      } else {
        try {
          this.isUseComment = true
          await submitterGrade({
            score: this.commentValue,
            todoId: this.id,
          })
          this.showComment = false
          this.isUseComment = false
          Toast(this.$t('已完成点评'))
          this.$router.push('representative')
        } catch (error) {
          Toast.fail(error.response.data)
        } finally {
          this.showComment = false
          this.isUseComment = false
        }
      }
    },
    toInform() {
      this.showServicePeopel = false
      this.showAllocation = true
    },
    confirmSearch(data) {
      let people = data[0]
      let departmentId = people?.departmentId?.split(',')[0]
      this.servicePeopelName = people.name
      this.servicePeopelId = people.id
      this.servicePersonnerlDpt = people.id + '-' + departmentId
      this.showServicePeopel = false
      this.showAllocation = true
    },
    async getRefInfo(appointmentId) {
      if (!appointmentId) return
      this.getInfo(appointmentId)
      this.getAreaId(this.user.companyId)
      this.getUsers(this.user.companyId)
    },
    async hasUser(user, token) {
      if (!user) {
        if (token) {
          const newUser = await queryStaffToekn({ token })
          if (newUser && newUser.token) {
            localStorage.setItem('user', JSON.stringify(newUser))
            localStorage.setItem(
              'cCode',
              JSON.stringify({ code: newUser.companyCode })
            )
            this.user = newUser
          } else {
            this.$router.push(
              `/?appointmentId=${this.appointmentId}&companyCode=${this.companyCode}`
            )
          }
        } else {
          this.$router.push(
            `/?appointmentId=${this.appointmentId}&companyCode=${this.companyCode}`
          )
        }
      } else {
        this.user = user
        // this.getAreaId(this.user.companyId)
      }
    },
  },
  computed: {
    checkTest() {
      return (
        (this.agree == null || this.agree == undefined) && this.ifPast == false
      )
    },
  },
  // watch: {
  //   showMessage() {
  //     if (this.showMessage) {
  //      this.$refs.getFocus.focus()
  //     }
  //   },
  // },
  created() {
    this.isVideoconferencing = localStorage.getItem('isVideoconferencing')
    this.$route.query.ifDetail && (this.ifDetail = true)
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.appointmentId = this.$route.query.appointmentId
    this.companyCode = this.$route.query.companyCode
    this.checkState = this.$route.query.state
    let user = JSON.parse(localStorage.getItem('user'))
    let token = this.$route.query.token
    this.hasUser(user, token)
    this.getRefInfo(this.$route.query.appointmentId)
  },
}
</script>
<style lang="less" scoped>
.navBar {
  background: #ffffff;
  line-height: 50px;
  text-align: center;
  font-size: 18px;

  // border-bottom: 1px #ededed solid;
  .title {
    font-size: 17px;
    font-weight: 500;
    color: #333333;
  }
}

.templateSend {
  min-height: 100vh;
  background: #edf0f6;
  color: #666666;
  position: relative;

  .mainContent {
    padding: 0 16px;
    background: #fefffe;
  }

  .mettingBoard {
    width: 343px;
    min-height: 126px;
    padding: 12px;
    background: #f4f4f4;
    border-radius: 4px;
    // margin-bottom: 20px;

    /deep/.van-field__control {
      font-size: 20px;
      font-weight: 600;
      color: #202020;
    }

    .mettingDet {
      padding: 0 6px;
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
    }

    .mettingDetTime {
      padding: 0 6px;
      display: flex;
      align-items: flex-start;
      margin-bottom: 8px;

      img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
    }

    .mettingName {
      font-family: AlibabaPuHuiTi_2_55_Regular;
      font-size: 14px;
      color: #1e2329;
      line-height: 20px;
      width: 200px;
      white-space: nowrap;
      /* 禁止换行 */
      overflow: hidden;
      /* 隐藏溢出内容 */
      text-overflow: ellipsis;
      /* 显示省略号 */
    }

    .mettingNameTime {
      font-family: AlibabaPuHuiTi_2_55_Regular;
      font-size: 14px;
      color: #1e2329;
      line-height: 20px;
      width: 220px;
      word-break: break-all;
      word-break: break-word;
    }

    .mettingBlue {
      font-size: 14px;
      font-weight: 400;
      color: #1377ec;
      line-height: 20px;
      width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
    }
  }
}

.header {
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: self-start;
  position: relative;
  padding: 19px 16px 0;
}

.headerTitle {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: self-start;
}

.statusImg {
  position: absolute;
  width: 70px;
  height: 70px;
  top: 5px;
  right: 16px;
}

.mettingTitle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #1e2329;
  margin-bottom: 8px;
}

.mettingTimeDay {
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-size: 14px;
  color: #707a8a;
}

.meetingInfo {
  background: #ffffff;
  padding-bottom: 20px;
  margin-bottom: 12px;
}

.approveInfo {
  background: #ffffff;
  padding: 16px 16px 60px;
}

.approveInfoTitle {
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-size: 16px;
  color: #1e2329;
  line-height: 22px;
  margin-bottom: 12px;
}

.approveTitle {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
}

.approveTitleLeft {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.approveTitleLeftTop {
  display: flex;
  align-items: flex-start;
  margin-bottom: 4px;
}

.approveTitleName {
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-size: 16px;
  color: #1e2329;
  line-height: 22px;
  overflow-wrap: break-word;
  word-break: break-word;
  /* 容器设置 */
  max-width: 145px;
}

.approveTitleTitme {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #646b73;
  line-height: 17px;
}

.approveTitleLine {
  width: 0px;
  height: 12px;
  border-left: 1px solid #b7bdc6;
  margin-left: 12px;
  margin-right: 11px;
  margin-top: 4px;
}

.approveTitleOk {
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-size: 16px;
  // color: #0ECB81;
  line-height: 22px;
}

// .approveTitleRefuse {
//   font-family: AlibabaPuHuiTi_2_55_Regular;
//   font-size: 16px;
//   color: #FF4D4F;
//   line-height: 22px;
// }

.approveDo {
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-size: 14px;
  color: #646b73;
  line-height: 20px;
}

.approveChange {
  margin-top: 8px;
  width: 323px;
  height: 72px;
  background: #f5f5f5;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.approveChangeSmall {
  margin-top: 8px;
  width: 323px;
  height: 44px;
  background: #f5f5f5;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.changeLabel {
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-size: 14px;
  color: #1e2329;
  margin-right: 8px;
}

.changeText {
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-size: 14px;
  color: #1e2329;
}

.changeTextLong {
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-size: 14px;
  color: #1e2329;
  width: 200px;
  white-space: nowrap;
  /* 禁止换行 */
  overflow: hidden;
  /* 隐藏溢出内容 */
  text-overflow: ellipsis;
  /* 显示省略号 */
}

.approveCancel {
  width: 313px;
  background: #f5f5f5;
  border-radius: 6px;
  padding: 12px 13px 11px 16px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-size: 14px;
  color: #1e2329;
  margin-top: 8px;
  box-sizing: border-box;
}

/deep/.van-popup {
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  background-color: #f2f4f7;
}

.popupStyle {
  height: 362px;
  width: 100%;
  padding: 8px 12px 14px;
}

.popupHeader {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 56px;
  margin-bottom: 12px;
  position: relative;
}

.popupClose {
  position: absolute;
  left: 12px;
  top: 16px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #1e2329;
}

.popupTitle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #1e2329;
}

.popupText {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #474d57;
  padding-left: 11px;
  // margin-bottom: 190px;
}

.popupRemark {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #b7bdc6;
  margin-top: 4px;
}

.bookBox {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 38px;
}

.bookBoxOk {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 70px;
}

.bookBoxOkOther {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 45px;
}

.bookBoxRevoke {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 198px;
}

.bookBoxCancel {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.blue-btn {
  width: 351px;
  height: 46px;
  background: #3972ff;
  border-radius: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
}

.grey-btn {
  width: 351px;
  height: 46px;
  background: rgba(183, 189, 198, 0.6);
  border-radius: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
}

.popupBlock {
  width: 351px;
  height: 72px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 24px;
  margin-bottom: 12px;
}

.popupOk {
  width: 351px;
  height: 72px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  // justify-content: center;
  align-items: center;
  padding-left: 24px;
  // margin-bottom: 12px;
}

.popupOkOther {
  width: 351px;
  height: 92px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 24px;
  // margin-bottom: 12px;
}

.popupComment {
  width: 351px;
  height: 72px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  // justify-content: center;
  align-items: center;
  padding-left: 24px;
  margin-bottom: 146px;
}

.commentStyle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #474d57;
}

.timeListTitle {
  height: 56px;
  line-height: 56px;
  border-bottom: 1px solid #ebebeb;
  padding-left: 20px;
}

.timeList {
  position: relative;
  height: 424px;
  border-bottom: 1px solid #ebebeb;
  padding-left: 16px;
  overflow-y: auto;
  overflow-x: hidden;

  .timeListCard {
    height: 52px;
  }

  .van-checkbox__label {
    width: 330px;
  }

  .timeListRange {
    display: block;
    border-bottom: 1px solid #ebebeb;
    padding-left: 6px;
    font-size: 16px;
    height: 52px;
    width: 375px;
    line-height: 51px;

    .extra {
      padding-left: 24px;
    }
  }
}

.dropdownImg {
  width: 20px;
  height: 20px;
  transform: rotate(270deg);
}

.okTextStyle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #1e2329;
}

.okTextGreyStyle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #b7bdc6;
}

.footerStyle {
  width: 375px;
  height: 72px;
  background: #ffffff;
  margin-top: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.refuseButton {
  width: 157px;
  height: 40px;
  border-radius: 16px;
  border: 1px solid #f6465d;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #f6465d;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
}

.refuseButtonSmall {
  width: 100px;
  height: 40px;
  border-radius: 16px;
  border: 1px solid #f6465d;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #f6465d;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
}

.okButton {
  width: 157px;
  height: 40px;
  border-radius: 18px;
  border: 1px solid #3972ff;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #3972ff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.okButtonSmall {
  width: 100px;
  height: 40px;
  border-radius: 18px;
  border: 1px solid #3972ff;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #3972ff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
}

.okButtonGray {
  width: 157px;
  height: 40px;
  border-radius: 18px;
  border: 1px solid #b7bdc6;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #474d57;
  display: flex;
  justify-content: center;
  align-items: center;
}

.okButtonGraySmall {
  width: 100px;
  height: 40px;
  border-radius: 18px;
  border: 1px solid #b7bdc6;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #474d57;
  display: flex;
  justify-content: center;
  align-items: center;
}

.allocationBotton {
  width: 335px;
  height: 40px;
  border-radius: 20px;
  border: 1px solid #3972ff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 9px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #3972ff;
}

.allocationBottonGray {
  width: 327px;
  height: 40px;
  border-radius: 20px;
  border: 1px solid #b7bdc6;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 9px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #474d57;
}

.bookBoxAllocation {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 154px;
}

.mettingNameText {
  width: 83px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-size: 14px;
  color: #707a8a;
}

.danger-btn {
  width: 351px;
  height: 46px;
  background: #ff4d4f;
  border-radius: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
}

/deep/ .van-step__circle {
  width: 8px;
  height: 8px;
  background: #1890FF;
  // border: 3px solid #FFFF
}

/deep/ .van-step__line {
  background-color: #E2E8F6 !important;
}
</style>
